import React, { ChangeEvent, KeyboardEvent, useRef, useState, useEffect } from 'react'

import { clearNumberFormatter } from '../../utils/Formatters'

export interface IProps {
  rf?: string
  id?: string
  name?: string
  unit?: string
  maxLength?: number
  inputClass?: string
  min?: number
  max?: number
  value: number
  disabled?: boolean
  userTracking?: any
  trackElement?: string
  format?: (value: string) => void
  onChange?: (value: number | null) => void
  onChangeComplete?: (value: number | null) => void
}

const NumbersOnlyInput = ({
  name,
  rf,
  maxLength,
  disabled,
  inputClass,
  min,
  max,
  value,
  unit,
  id,
  userTracking,
  trackElement,
  format,
  onChange,
  onChangeComplete
}: IProps) => {
  const inputRef = useRef<HTMLInputElement>()

  const getValue = (inputNumber: string) => {
    const val = inputNumber !== null && inputNumber !== undefined ? inputNumber : ''
    if (format) {
      return format.call(this, val)
    }
    return val
  }

  const [inputValue, setInputValue] = useState<string | null>(getValue(value?.toString()))

  useEffect(() => {

    const tempValue = clearNumberFormatter(inputValue)
    if (value !== +tempValue) {
      if (isNaN(value)) {
        setInputValue(null)
      } else {
        setInputValue(getValue(value?.toString()))
      }
    }
  }, [value])

  const getValidatedValue = (): number | null => {
    if((inputValue === undefined && inputValue === null) ||
      (min === undefined  && max === undefined && inputValue === '')){
      return null
    }
    const tempvalue =  +clearNumberFormatter(inputValue)
    if (min && tempvalue < min) {
      return min
    }
    if (max && tempvalue > max) {
      return max
    }

    return tempvalue
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let tempValue: string
    const numbers = /^\d+$/
    const newValue = clearNumberFormatter(e.target.value)
    const isOnlyNums = numbers.test(newValue) || newValue === ''

    if(!isOnlyNums) {
      return
    }

      if (newValue === '') {
        tempValue = ''
      } else {
        tempValue = e.target.value
      }


    setInputValue(tempValue)
    if (onChange) {
      onChange(+tempValue)
    }
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      inputRef.current.blur()
    }
  }

  const handleBlur = () => {
    setInputValue(getValue(inputValue))
    if (!onChangeComplete) {
      return
    }
    if (userTracking) {
      userTracking.onInputChange(trackElement)
    }

    const validatedValue = getValidatedValue()
    if (validatedValue === null) {
      setInputValue('')
      onChangeComplete(null)
    } else {
      setInputValue(getValue(validatedValue?.toString()))
      onChangeComplete(+clearNumberFormatter(validatedValue))
    }
  }

  const handleFocus = () => {
    inputRef.current.setSelectionRange(0, inputRef.current.value.length)
  }

  return (
    <>
      <input
        data-testid={rf}
        type='tel'
        disabled={disabled}
        name={name}
        id={id}
        value={inputValue}
        className={inputClass}
        maxLength={maxLength}
        ref={inputRef}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        onChange={handleChange}
      />
      {unit && <label htmlFor={id}>{unit}</label>}
    </>
  )
}

export default NumbersOnlyInput
